import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api/apiClient';

export default function ParentDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    async function load() {
      try {
        const res = await api.get(`/admin/parents/${id}`);
        setData(res.data.data);
      } catch (err) {
        setError(err.response?.data?.message || 'Unable to load parent');
      }
    }
    load();
  }, [id]);

  if (error) return <div className="error-message">{error}</div>;
  if (!data) return <div style={{ padding: 32 }}>Loading...</div>;

  const { parent, students } = data;

  return (
    <div>
      {/* Back Button */}
      <button onClick={() => navigate('/parents')} className="back-button" style={{ margin: '24px 0 20px 24px' }}>
        ← Back to Parents
      </button>

      {/* Parent Header */}
      <div style={{ background: '#fff', borderRadius: 12, padding: 24, margin: '0 24px 20px', border: '1px solid #e5e7eb' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
          <div style={{
            width: 64, height: 64, borderRadius: '50%', background: '#7c3aed',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#fff', fontSize: 24, fontWeight: 700
          }}>
            {parent.name?.[0] || '?'}
          </div>
          <div>
            <h2 style={{ margin: 0, fontSize: 22 }}>{parent.name}</h2>
            <p style={{ margin: '4px 0 0', color: '#6b7280', fontSize: 14 }}>
              {parent.phone} · {parent.email}
            </p>
          </div>
          <span style={{
            marginLeft: 'auto', padding: '4px 12px', borderRadius: 20,
            background: parent.is_active ? '#d1fae5' : '#fee2e2',
            color: parent.is_active ? '#065f46' : '#991b1b', fontSize: 13
          }}>
            {parent.is_active ? 'Active' : 'Inactive'}
          </span>
        </div>
      </div>

      {/* Linked Students */}
      <div style={{ background: '#fff', borderRadius: 12, padding: 24, margin: '0 24px', border: '1px solid #e5e7eb' }}>
        <h3 style={{ marginTop: 0, fontSize: 16 }}>
          Linked Children ({students.length})
        </h3>

        {students.length ? (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16 }}>
            {students.map((s) => (
              <div
                key={s.id}
                // onClick={() => navigate(`/students/${s.id}`)}
                onClick={() => navigate(`/students/${s.id}?from=parents`)}

                style={{
                  border: '1px solid #e5e7eb', borderRadius: 10, padding: 16,
                  cursor: 'pointer', transition: 'box-shadow 0.2s',
                  display: 'flex', alignItems: 'center', gap: 14
                }}
                onMouseEnter={e => e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.10)'}
                onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
              >
                {/* Avatar */}
                <div style={{
                  width: 48, height: 48, borderRadius: '50%', background: '#2563eb',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: '#fff', fontSize: 18, fontWeight: 700, flexShrink: 0
                }}>
                  {s.full_name?.[0] || '?'}
                </div>

                {/* Info */}
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600, fontSize: 15, color: '#111827' }}>
                    {s.full_name}
                    {s.is_primary ? <span style={{ marginLeft: 6, fontSize: 12 }}>⭐</span> : ''}
                  </div>
                  <div style={{ fontSize: 13, color: '#6b7280', marginTop: 2 }}>
                    {s.class_grade} · {s.branch_name}
                  </div>
                  <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 2 }}>
                    {s.student_id} · {s.relation}
                  </div>
                </div>

                {/* Arrow */}
                <span style={{ color: '#9ca3af', fontSize: 18 }}>→</span>
              </div>
            ))}
          </div>
        ) : (
          <p style={{ color: '#9ca3af' }}>No children linked to this parent</p>
        )}
      </div>
    </div>
  );
}
